/* Zubehör-PDP „Dezent“ (25.10.2026, Entwurf 3 „Set“) – sections/sushi-dzz-pdp ([data-za]), sushi-dzz-set ([data-zaset]),
   sushi-dzz-mount (Video). Varianten, Preise, Lieferzeit, Passt an (Bike-Wahl nur auf der Seite, seit 03.11.2026 nicht mehr gemerkt,
   auch ?modell= wie der Ersatzteilfinder), Galerie, Reiter, Warenkorb (/cart/add.js + Cart-Drawer), Benachrichtigung (Klaviyo
   Back-in-Stock wie sushi-dezent-pdp.js), Set mit Summe (Empfehlungen über sections/sushi-dzz-recs), Video erst nach Klick. */
(function () {
  if (window.__sushiZa) return;
  window.__sushiZa = true;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const eur = (c) => (c / 100).toLocaleString('de-DE', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' €';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* Bot-Schutz der Anmeldeformulare (31.10.2026): unsichtbares Feld „website“, das nur Bots ausfüllen, und mindestens 2 s zwischen
     Laden der Seite und Absenden. Trifft eins zu, zeigt das Formular „Danke“, schickt aber nichts an Klaviyo. */
  const HP_T0 = Date.now();
  const hpAdd = (f) => { if (f && !f.querySelector('.sushi-hp')) f.insertAdjacentHTML('beforeend', '<input class="sushi-hp" type="text" name="website" value="" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);opacity:0;pointer-events:none">'); };
  const hpBot = (f) => { const h = f.querySelector('.sushi-hp'); return !!(h && h.value) || Date.now() - HP_T0 < 2000; };
  const GEN = { '30p': 'SUSHI BIKE 3.0+', '30': 'SUSHI BIKE 3.0', plus: 'Maki+ / California Roll+', g1: 'SUSHI BIKE der 1. Generation', tabi: 'SUSHI BIKE TABI' };
  const FROM_URL = { gen3plus: '30p', gen3: '30', gen2_asia: 'plus', gen2_spain: 'plus', gen1: 'g1' };
  const T = { cartError: 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.', notifyOk: 'Danke! Wir schreiben dir, sobald es wieder da ist.',
    notifyError: 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.' };
  let tT;
  const toast = (t) => { const e = $('[data-toast]'); if (!e) return; e.textContent = t; e.hidden = false; clearTimeout(tT); tT = setTimeout(() => (e.hidden = true), 2600); };

  /* Nach dem Hinzufügen öffnet sich die Warenkorb-Meldung des Themes; klappt die nicht, steht unter dem Knopf
     „Liegt im Warenkorb“ mit Link. Fehler der Theme-Skripte halten das nicht mehr auf (25.10.2026). */
  async function addToCart(items, btn, done) {
    if (btn.disabled) return;
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = { items };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map((s) => s.id).join(',');
      body.sections_url = location.pathname;
    }
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (done) done.hidden = true;
    let res;
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      res = await r.json();
      if (!r.ok || res.status) throw res;
    } catch (err) {
      const msg = (err && err.description) || T.cartError;
      if (done) { done.textContent = msg; done.hidden = false; } else toast(msg);
      return;
    } finally {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
    const first = res.items && res.items[0];
    if (first) { res.key = first.key; res.id = first.variant_id; }
    let shown = false;
    try {
      if (cart && cart.renderContents && res.sections) {
        if (cart.setActiveElement) cart.setActiveElement(btn);
        cart.classList.remove('is-empty');
        cart.renderContents(res);
        shown = true;
      }
    } catch (e) { console.warn('sushi-dezent-za: Warenkorb-Meldung', e); }
    try { if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sushi-dezent-za', productVariantId: items[0].id, cartData: res }); } catch (e) {}
    if (!shown) {
      const n = res.items ? res.items.length : 1;
      const msg = (n > 1 ? n + ' Teile liegen' : 'Liegt') + ' im Warenkorb. ';
      if (done) {
        done.textContent = msg;
        const a = document.createElement('a');
        a.href = root + 'cart';
        a.textContent = 'Zum Warenkorb';
        done.append(a);
        done.hidden = false;
      } else toast(msg);
    }
  }

  function initPdp(el) {
    let D;
    try { D = JSON.parse($('[data-za-json]', el).textContent); } catch (e) { return; }
    const S = { opt: [], gen: '' };
    try { const m = new URLSearchParams(location.search).get('modell'); if (m && FROM_URL[m]) S.gen = FROM_URL[m]; } catch (e) {}
    const ONLY = {};
    (D.only || '').split('|').forEach((x) => { const i = x.indexOf(':'); if (i > 0) ONLY[x.slice(0, i).trim()] = x.slice(i + 1).trim(); });
    const FIT = (D.fit || '').split(' ').filter(Boolean);
    const start = D.variants.find((v) => v.id === D.start) || D.variants.find((v) => v.av) || D.variants[0];
    S.opt = [...start.o];
    const cur = () => D.variants.find((v) => v.o.every((x, i) => x === S.opt[i])) || null;
    const delivery = (v) => {
      if (D.fixed || !v.dmin || !v.dmax || !D.unit[v.dunit]) return D.delivery;
      const u = D.unit[v.dunit], r = v.dmin === v.dmax ? v.dmin : v.dmin + '–' + v.dmax;
      return 'Lieferung in ' + r + ' ' + (v.dmax === 1 ? u[0] : u[1]);
    };
    const msgEl = $('[data-fitmsg]', el), msgDefault = msgEl ? msgEl.textContent : '';

    function render() {
      const v = cur();
      $$('[data-opt]', el).forEach((b) => {
        const i = +b.dataset.opt, test = [...S.opt];
        test[i] = b.dataset.val;
        const tv = D.variants.find((x) => x.o.every((y, k) => y === test[k]));
        b.setAttribute('aria-pressed', b.dataset.val === S.opt[i]);
        b.classList.toggle('out', !tv || !tv.av);
      });
      $$('[data-optout]', el).forEach((o) => (o.textContent = S.opt[+o.dataset.optout] || ''));
      if (v) {
        $$('[data-out=price]', el).forEach((e) => (e.textContent = eur(v.p)));
        $$('[data-out=compare]', el).forEach((e) => { e.textContent = v.c > v.p ? eur(v.c) : ''; e.hidden = !(v.c > v.p); });
        $$('[data-out=save]', el).forEach((e) => { e.textContent = v.c > v.p ? 'Du sparst ' + eur(v.c - v.p) : ''; e.parentElement.hidden = !(v.c > v.p); });
        $$('[data-out=barprice]', el).forEach((e) => (e.textContent = eur(v.p) + (v.av ? ' · ' + delivery(v) : ' · gerade ausverkauft')));
        $$('[data-out=stock]', el).forEach((e) => (e.innerHTML = v.av ? '<i class="ok"></i>Auf Lager – ' + delivery(v) : '<i></i>Gerade ausverkauft'));
        const id = $('[data-za-id]', el);
        if (id) id.value = v.id;
        $$('[data-cta]', el).forEach((b) => (b.hidden = !v.av));
        $$('[data-notify]', el).forEach((f) => (f.hidden = v.av));
        if (v.img) $$('[data-gallery-main]', el).forEach((m) => { m.src = v.img; m.removeAttribute('srcset'); });
        document.dispatchEvent(new CustomEvent('za:variant', { detail: v }));
      }
      if (msgEl) {
        if (!S.gen) { msgEl.className = 'za-fit__msg'; msgEl.textContent = msgDefault; }
        else {
          const ok = FIT.includes(S.gen), alt = D.alt && D.alt[S.gen];
          msgEl.className = 'za-fit__msg ' + (ok ? 'ok' : 'no');
          msgEl.textContent = ok ? '✓ Passt an dein ' + GEN[S.gen] + (ONLY[S.gen] ? ' (' + ONLY[S.gen] + ')' : '') + '.' : '✕ Passt leider nicht an dein ' + GEN[S.gen] + '.';
          if (!ok && (alt || D.coll)) {
            msgEl.append(alt ? ' Für dein Bike: ' : ' ');
            const a = document.createElement('a');
            a.className = 'dz-link';
            a.href = alt ? alt.url : D.coll;
            a.textContent = alt ? alt.name : 'Zubehör, das passt';
            msgEl.append(a);
          }
        }
      }
      $$('[data-gen]', el).forEach((b) => b.setAttribute('aria-pressed', b.dataset.gen === S.gen));
    }

    el.addEventListener('click', (e) => {
      const o = e.target.closest('[data-opt]');
      if (o) {
        const i = +o.dataset.opt;
        S.opt[i] = o.dataset.val;
        if (!cur() || !cur().av) {
          const alt = D.variants.find((x) => x.o[i] === o.dataset.val && x.av) || D.variants.find((x) => x.o[i] === o.dataset.val);
          if (alt && !cur()) S.opt = [...alt.o];
        }
        render();
        return;
      }
      const g = e.target.closest('[data-gen]');
      if (g) { S.gen = S.gen === g.dataset.gen ? '' : g.dataset.gen; render(); return; }
      const t = e.target.closest('[data-thumb]');
      if (t) {
        const gal = t.closest('[data-gallery]'), m = $('[data-gallery-main]', gal);
        m.src = t.dataset.thumb; m.removeAttribute('srcset');
        $$('[data-thumb]', gal).forEach((x) => x.toggleAttribute('aria-current', x === t));
        return;
      }
      const tab = e.target.closest('[data-tab]');
      if (tab) {
        $$('[data-tab]', el).forEach((b) => b.setAttribute('aria-selected', b === tab));
        $$('[data-panel]', el).forEach((p) => (p.hidden = p.dataset.panel !== tab.dataset.tab));
        return;
      }
      const w = e.target.closest('[data-which]');
      if (w) { const b = document.getElementById(w.getAttribute('aria-controls')); if (b) { b.hidden = !b.hidden; w.setAttribute('aria-expanded', !b.hidden); } }
    });
    const form = $('.pd-form', el), done = $('[data-done]', el);
    if (form) form.addEventListener('submit', (e) => { e.preventDefault(); const v = cur(); if (v && v.av) addToCart([{ id: v.id, quantity: 1 }], $('[data-cta]', el), done); });
    const nf = $('[data-notify]', el);
    if (nf) hpAdd(nf);
    if (nf) nf.addEventListener('submit', async (e) => {
      e.preventDefault();
      const inp = $('input', nf);
      if (inp.hidden) { inp.hidden = false; inp.required = true; inp.focus(); return; }
      if (!inp.checkValidity()) { inp.reportValidity(); return; }
      if (hpBot(nf)) { nf.hidden = true; done.textContent = T.notifyOk; done.hidden = false; return; }
      const payload = { data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: inp.value } } }, channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + cur().id } } } } };
      try {
        const r = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Xz24E7', { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2026-10-15' }, body: JSON.stringify(payload) });
        if (!r.ok) throw new Error(r.status);
        nf.hidden = true;
        done.textContent = T.notifyOk;
      } catch (err) { done.textContent = T.notifyError; }
      done.hidden = false;
    });
    render();
  }

  function initSet(el) {
    const max = +el.dataset.max || 3, items = $('[data-set-items]', el);
    function sum() {
      const on = $$('[data-set]', el).filter((i) => i.checked && !i.closest('.za-item--out'));
      const total = on.reduce((s, i) => s + +i.dataset.price, 0);
      $('[data-settotal]', el).textContent = eur(total);
      $('[data-setcount]', el).textContent = on.length === 1 ? '1 Teil' : on.length + ' Teile';
      $('[data-setbtn]', el).textContent = on.length === 1 ? 'In den Warenkorb' : on.length + ' Teile in den Warenkorb';
    }
    document.addEventListener('za:variant', (e) => {
      const v = e.detail, m = $('[data-main]', el);
      if (!m) return;
      m.dataset.variant = v.id; m.dataset.price = v.p;
      const row = m.closest('[data-setrow]');
      $('[data-setprice]', row).textContent = eur(v.p);
      const s = $('[data-setcmp]', row); s.textContent = v.c > v.p ? eur(v.c) : ''; s.hidden = !(v.c > v.p);
      const done = $('[data-setdone]', el); if (done) done.hidden = true;
      m.closest('[data-setrow]').classList.toggle('za-item--out', !v.av);
      sum();
    });
    el.addEventListener('change', (e) => {
      const s = e.target.closest('[data-setvar]');
      if (s) {
        const o = s.selectedOptions[0], row = s.closest('[data-setrow]'), i = $('[data-set]', row);
        i.dataset.variant = s.value; i.dataset.price = o.dataset.price; i.checked = true;
        $('[data-setprice]', row).textContent = eur(+o.dataset.price);
        const c = +o.dataset.cmp, sc = $('[data-setcmp]', row); sc.textContent = c > +o.dataset.price ? eur(c) : ''; sc.hidden = !(c > +o.dataset.price);
      }
      if (e.target.matches('[data-set]') || s) sum();
    });
    el.addEventListener('click', (e) => {
      const b = e.target.closest('[data-setbtn]');
      if (!b) return;
      const on = $$('[data-set]', el).filter((i) => i.checked && !i.closest('.za-item--out'));
      if (!on.length) return;
      addToCart(on.map((i) => ({ id: +i.dataset.variant, quantity: 1 })), b, $('[data-setdone]', el));
    });
    if (el.dataset.recs) {
      fetch(el.dataset.recs).then((r) => r.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html'), seen = new Set([el.dataset.h]);
        let n = 0;
        $$('[data-setrow]', doc).forEach((row) => {
          if (n >= max || seen.has(row.dataset.h)) return;
          seen.add(row.dataset.h); items.append(document.importNode(row, true)); n++;
        });
        if (n > 0) { el.hidden = false; sum(); }
      }).catch(() => {});
    }
    sum();
  }

  /* Montagevideo: erst nach Klick laden (youtube-nocookie) */
  document.addEventListener('click', (e) => {
    const y = e.target.closest('[data-yt]');
    if (!y) return;
    const box = document.createElement('div');
    box.className = 'za-video za-video--on';
    const f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(y.dataset.yt) + '?autoplay=1&rel=0&playsinline=1';
    f.title = 'Montagevideo';
    f.allow = 'autoplay; encrypted-media; picture-in-picture';
    f.allowFullscreen = true;
    box.append(f);
    y.replaceWith(box);
  });

  const start = () => { $$('[data-zaset]').forEach(initSet); $$('[data-za]').forEach(initPdp); };  /* Set zuerst: hört auf za:variant */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
